import { useQuery } from '@tanstack/react-query';
import { useDataService } from '@/lib/service-context';
import type { ProSettings } from '@erp/data-access/interfaces';

/** Tenant pro-portal settings (default commission + delivery). Tenant-shared,
 *  read-mostly — cached like the catalogue. */
export function useProSettings() {
  const ds = useDataService();
  return useQuery<ProSettings>({
    queryKey: ['pro-settings'],
    queryFn: () => ds.proSettings.getForCurrentTenant(),
    staleTime: 5 * 60_000,
    gcTime: 24 * 60 * 60_000,
  });
}
